/**
 * SIMS-8923 — the one place the consent-form size cap is defined.
 *
 * It used to be a bare `10 * 1024 * 1024` inside UploadButton, and the Enroll Participant
 * modal (which uses a raw <input type="file">, not UploadButton) had no cap at all. Both
 * numbers now come from here so the upload entry points cannot disagree.
 *
 * 10 MB is what the field asked for, and it is reachable now that EVERY consent path
 * uploads straight to S3 via a presigned PUT. It was NOT reachable through the API: as
 * base64 in a request body the file inflates by 4/3, so 10 MB becomes ~13.4 MB and exceeds
 * both Lambda's 6 MB synchronous payload ceiling and API Gateway's 10 MB one. That is why
 * this constant was briefly 3 MB — the number was sized against the transport, and the
 * transport is what changed.
 *
 * This cap is a courtesy: it fails fast, before the upload, with a message naming the
 * limit. The enforcement is server-side — `MAX_CONSENT_FILE_BYTES` in backend-2's
 * `consent-upload.service.ts` bounds the slot request and is signed into the presigned URL,
 * so S3 itself refuses a larger upload. Keep the two numbers equal; if they ever diverge,
 * the server's is the one that decides.
 */
export const MAX_CONSENT_FILE_BYTES = 10 * 1024 * 1024;

export const MAX_CONSENT_FILE_LABEL = "10 MB";

/** MIME types accepted for a signed consent form. Mirrors the backend's DTO validation. */
export const ACCEPTED_CONSENT_MIME_TYPES = [
	"image/png",
	"image/jpeg",
	"application/pdf",
];
